import React, { useRef, createRef, useCallback } from "react"
import { css } from "@emotion/react"
import { useBreakpoint } from "gatsby-plugin-breakpoints"
import { fontSize, globalColors, cmsStyle } from "../css-functions"

const WorksArchivedList = (props) => {
  const target = useRef([])
  const bp = useBreakpoint()

  props.detail.edges.forEach((_, i) => {
    target.current[i] = createRef()
  })

  const scrollTo = useCallback((elem) => {
    const els = document.querySelectorAll(".archiveDetail")

    const handleScrollTo = (elem) => {
      elem.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    }

    els.forEach(el => {
      el.addEventListener("transitionend", () => handleScrollTo(elem))
    })

    return () => {
      els.forEach(el => {
        el.removeEventListener("transitionend", () => handleScrollTo(elem))
      })
    }
  }, [])

  const style = {
    contentWrapper: css`
      margin: 0 auto;
      max-width: 800px;
    `,
    radio: css`
      display: none;
      &:checked {
        & + .archiveSection {
          &--last {
            border-width: 32px;
          }
          & > .archiveheader {
            &::after {
              transform: translateY(-30%) rotate(225deg);
            }
          }
          & > .archiveDetail {
            padding: 20px;
            height: fit-content;
          }
        }
      }
    `,
    section: css`
      border-bottom: 1px solid ${globalColors.white};
      &.archiveSection--last {
        border-bottom: 0 solid ${globalColors.gold};
      }
    `,
    header: css`
      height: ${ bp.isTablet ? '40px' : '32px' };
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: ${globalColors.gold};
      position: relative;
      cursor: pointer;
      ${ bp.isTablet ? fontSize(16) : fontSize(14) };
      letter-spacing: 0.1em;
      color: ${globalColors.header};
      &::after {
        width: 12px;
        height: 12px;
        content: "";
        display: block;
        border-right: 1px solid ${globalColors.white};
        border-bottom: 1px solid ${globalColors.white};
        position: absolute;
        top: 50%;
        right: 16px;
        transform: translateY(-70%) rotate(45deg);
        transition: transform 0.2s ease-in-out;
      }
      &:hover {
        opacity: 0.9;
        transition: opacity 0.2s ease;
      }
    `,
    detail: css`
      padding: 0 20px;
      height: 0;
      background-color: ${globalColors.white};
      border-right: 8px solid ${globalColors.gold};
      border-left: 8px solid ${globalColors.gold};
      overflow: hidden;
      transition: padding 0.2s ease, border 0.2s ease;
    `,
    markdown: css`
      ${cmsStyle.archives.markdown}
    `,
  }

  const dataLength = props.detail.edges.length

  return (
    <>
      {props.detail.edges.map(({ node }, index) => (
        <div
          ref={ target.current[index] }
          key={ node.id }
          css={ style.contentWrapper }
        >
          <input
            type="radio"
            role="button"
            aria-label="toggle detail"
            id={`archive-${props.keyword}-${node.fields.slug}`}
            name="archive-bonsekiten"
            css={style.radio}
            defaultChecked={index === 0 && true}
          />
          <section
            css={style.section}
            className={`archiveSection${dataLength === index + 1 ? " archiveSection--last" : ""}`}
          >
            {/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */}
            <label
              htmlFor={`archive-${props.keyword}-${node.fields.slug}`}
              css={style.header}
              className="archiveheader"
              onClick={ () => scrollTo(target.current[index === 0 ? index : index - 1].current) }
            >
              {node.frontmatter.title}
            </label>
            {/* eslint-enable jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */}
            <div
              css={style.detail}
              className="archiveDetail"
            >
              <div
                css={style.markdown}
                dangerouslySetInnerHTML={{ __html: node.html }}
              />
            </div>
          </section>
        </div>
      ))}
    </>
  )
}

export default WorksArchivedList